export default __webpack_public_path__ + "static/media/cartbackground2.c21a8117.png";